import { combineReducers } from 'redux'

import user from './user.js'

export const reducers = combineReducers({user})